import { Menu, MenuElement, MenuProps } from '@farol-ds/react'
import classNames from 'classnames'
import { forwardRef } from 'react'

import styles from './context-menu-content.module.scss'

export type ContextMenuContentElement = MenuElement

export type ContextMenuContentProps = MenuProps

const ContextMenuContent = forwardRef<ContextMenuContentElement, ContextMenuContentProps>(
  function ContextMenuContent(props, forwardedRef) {
    const { children, className, ...rest } = props

    const classes = classNames(styles.root, className)

    return (
      <Menu {...rest} orientation="vertical" className={classes} ref={forwardedRef}>
        {children}
      </Menu>
    )
  }
)

export default ContextMenuContent
